// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ogyn","amount":"Amount_amount__2xtNL","tip":"Amount_tip__2oSSK","tipHeader":"Amount_tipHeader__3gDIW","tipsWrap":"Amount_tipsWrap__24NTn"};